<template>
  <b-container>
    <b-row>
      <h2>{{ $t("system.systemIntegration.list") }}</h2>
      <success-fade-alert ref="alert" msg="Formulário exluido com sucesso" />
      <fade-alert-danger ref="danger" msg="Formulário não exluido" />
    </b-row>
    <br />
    <b-row>        
      <router-link :to="'../systemIntegration/create'">
        <b-button size="sm">{{ $t("geral.create") }}</b-button>
      </router-link>
    </b-row>
    <b-row>
      <b-table
        ref="MyForm"
        class="table-nowrap"
        :busy.sync="isBusy"
        :items="myProvider"
        :fields="fields"
        :per-page="tablePerPage"
        :current-page="tableCurrentPage">
        <template v-slot:cell(actions)="data">
            <router-link :to="'../systemIntegration/edit/' + data.item.id">
                <b-button size="sm">{{ $t("geral.editar") }}</b-button>
            </router-link>
        </template>
      </b-table>
    </b-row>
    <b-row>
      <b-col>
        <b-pagination
          v-model="tableCurrentPage"
          :total-rows="tableRowCount"
          :per-page="tablePerPage"
          first-number
          last-number
          aria-controls="table-tabela-proceda"
        />
      </b-col>
      <b-col>
        <label
          for="perPageSelect"
        >Exibindo {{ paginationFrom }} até {{ paginationTo }} de um total de {{ tableRowCount }}</label>
      </b-col>
      <b-col>
        <b-row>
          <b-col>
            <b-form-select
              v-model="tablePerPage"
              id="perPageSelect"
              size="sm"
              :options="tablePageOptions"
            />
          </b-col>
          <b-col>
            <label for="perPageSelect">Registros exibidos por página</label>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import FadeAlertDanger from "@/components/FadeAlertDanger.vue";
import SuccessFadeAlert from "@/components/SuccessFadeAlert.vue";

export default {
  components: {
    FadeAlertDanger,
    SuccessFadeAlert,
  },
  data: function () {
    return {
      isBusy: false,
      fields: [
        {
          key: "actions",
          label: "",
          tdClass: "table-col-dinamic-width",
        },
        {
          key: "id",
          sortable: false,
          label: "Id",
          tdClass: "table-col-dinamic-width",
        },
        { key: "displayName", sortable: true },
        { key: "name", sortable: true },
      ],
      tableRowCount: 0,
      tablePerPage: 10,
      tablePageOptions: [5, 10, 25, 50, 100, 150],
      tableCurrentPage: 1,
      tableSelectMode: "single",
      tableSelectedItem: [],
    };
  },
  computed: {
    paginationFrom() {
      return this.tablePerPage * (this.tableCurrentPage - 1) + 1;
    },
    paginationTo() {
      let to = this.paginationFrom - 1 + this.tablePerPage;
      if (to > this.tableRowCount) return this.tableRowCount;
      return to;
    },
  },
  methods: {
    myProvider(ctx, callback) {
        this.isBusy = true;

        let apiFilter = {
            currentPage: ctx.currentPage,
            perPage: ctx.perPage = ctx.perPage,
        };

        this.$apiChecklist
            .post("/systemIntegration/all/", apiFilter)
            .then((response) => {
                const items = response.data.items;
                console.log(response.data);
                this.isBusy = false;
                this.tableRowCount = response.data.totalItems;
                callback(items);
            }).catch((error) => {
                if(error.response.status == 401) {
                    this.$store.dispatch("logout").then(() => {
                        this.$router.push("/login");
                    });
                } else {
                    this.isBusy = false;
                    this.tableRowCount = 0;
                    callback([]);
                }
            });

        return null;
    },
    deleteForm(id) {
      this.$apiChecklist
        .get("/form/delete/" + id.toString())
        .then((response) => {
          this.$refs.MyForm.refresh();
          this.$refs.alert.show();
        })
        .catch((error) => {
          console.log(error.response);
          this.$refs.danger.msg =
            error.response.status + " - " + error.response.statusText;
          this.$refs.danger.show();
        });
    },
  },
};
</script>

